import React from "react";

const GmapsAddressInput = ({ inputProps }, ref) => {
  return (
    <input
      inputprops={{ "aria-label": "search google maps" }}
      className="map-input form-control"
      ref={ref}
      {...inputProps}
    />
  );
};

export default React.forwardRef(GmapsAddressInput);
